/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import withStyles from '@material-ui/core/styles/withStyles';

import LoginForm from '../common/Login/LoginForm';
import ResetPasswordForm from '../common/Login/ResetPasswordForm';
import CreateAccountForm from '../common/Login/CreateAccountForm';

import { main as MainStyle } from '../style/main';
import EventDispatcher from '../state/reducers/EventDispatcher';
import configEnv from '../config';

const { PERSIST_KEY } = configEnv;
const styles = ({ typography, palette }) => MainStyle(typography, palette);

const Components = {
    LoginForm,
    ResetPasswordForm,
    CreateAccountForm,
};

class AccountLogin extends Component {
    componentDidMount = () => {
        this.isAuthenticated(this.props);
    };

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillUpdate = (props) => {
        this.isAuthenticated(props);
    };

    isAuthenticated = (props) => {
        if (props) {
            const { callBack, handleClearPageData, history } = props;
            if (callBack && callBack.url) {
                history.replace(callBack.url);
                handleClearPageData();
            }
        }
    };

    render() {
        const { classes, module } = this.props;
        const Layout = Components[module];

        return (
            <>
                <div className={`${classes.main}`}>
                    <Layout />
                </div>
            </>
        );
    }
}

AccountLogin.propTypes = {
    classes: PropTypes.object.isRequired,
    module: PropTypes.string.isRequired,
    handleClearPageData: PropTypes.func, // eslint-disable-line react/no-unused-prop-types
};

AccountLogin.defaultProps = {
    handleClearPageData: () => { },
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        isAuthenticated: newState.isAuthenticated,
        callBack: newState.pageData.callBack,
    };
};

const mapDispatchToProps = (dispatch) => ({
    handleClearPageData: () => dispatch(EventDispatcher.handleClearPageData()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(withStyles(styles)(AccountLogin)));
